export default (targetWindow, allowedOrigin) => {
  return {
    post: (message) => {
      if (allowedOrigin !== false) {
        targetWindow.postMessage(message, allowedOrigin);
      }
    }
  };
};